import React from "react";
import './event_detail.css'

export default function EventDetail() {
    return (
        <div>Event Detail</div>
    )
}